// extracted by mini-css-extract-plugin
export default {"aside":"Sidebar_aside__AvRLa","visible":"Sidebar_visible__2CklE","icon":"Sidebar_icon__ceWEk","link":"Sidebar_link__m16eL"};